import React from 'react';

import {
  Table,
  TableRow,
  TableCell,
  Pagination,
} from '@unimed-fesp/components';

import { useSelector } from 'react-redux';

import FadeIn from '../../atoms/FadeIn';

import LoadingSpinning from '../../molecules/LoadingSpinning';

import TableUsuarioHeader from './TableUsuarioHeader';
import TableUsuarioEspelhoBody from './TableUsuarioEspelhoBody';

const TableUsariosEspelho = ({
  selectedUser,
  handleCheckUser,
  paginationParams,
  handleChangePage,
  setPaginationParams,
  handlePageChangeKeyDown,
}) => {
  const {
    loading,
    success,
    responseUsuarioEspelho: { total },
  } = useSelector((state) => state.usuario);

  if (loading) return <LoadingSpinning height="250px" />;

  return (
    <FadeIn>
      <Table
        head={<TableUsuarioHeader />}
        foot={
          success && (
            <TableRow>
              <TableCell colSpan={6}>
                <Pagination
                  total={total}
                  paginationParams={paginationParams}
                  setPaginationParams={setPaginationParams}
                  handlePageChangeKeyDown={handlePageChangeKeyDown}
                  callbackChangePage={handleChangePage}
                />
              </TableCell>
            </TableRow>
          )
        }
      >
        <TableUsuarioEspelhoBody
          selectedUser={selectedUser}
          handleCheckUser={handleCheckUser}
        />
      </Table>
    </FadeIn>
  );
};

export default TableUsariosEspelho;
